// Guard against a second registration when multiple Home hero sections render on the same page
if (!customElements.get('home-hero')) {
  customElements.define(
    'home-hero',
    class HomeHero extends HTMLElement {
      constructor() {
        super();

        this.fullWidthText = this.getAttribute('data-layout') === 'layout-large-text';
        this.heading = this.querySelector('.home-hero__heading');

        if (!this.fullWidthText) return;

        this.setup();

        // Needed because we split the heading with js and that could happen after this script runs
        this.observeForChanges(this.heading, this.setSize.bind(this));
      }

      observeForChanges(obj, callback) {
        var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

        if (!obj) return;

        if (MutationObserver) {
          var mutationObserver = new MutationObserver(callback);
          mutationObserver.observe(obj, { childList: true, subtree: true });
          return mutationObserver;
        } else if (window.addEventListener) {
          obj.addEventListener('DOMNodeInserted', callback, false);
          obj.addEventListener('DOMNodeRemoved', callback, false);
        }
      }

      setup() {
        this.setSize();
      }

      setSize() {
        const headingSpan = this.heading.querySelector('span');

        if (!headingSpan) return;

        const width = window.innerWidth;
        const headingWidth = headingSpan.offsetWidth;
        const fontSize = parseInt(window.getComputedStyle(headingSpan).fontSize);
        const vw = (((width / headingWidth) * fontSize) / width) * 100 + 1;

        headingSpan.style.fontSize = `${vw}vw`;
      }
    }
  );
}
